<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				Key Search
			</li>
			<li *ngIf="activation" class="breadcrumb-item">
				<a href="javascript:void(0)" (click)="onCancel()">{{ activation.key }}</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">Commercial</li>
			<span *ngIf="loading || saving" style="text-align: center;">
				<app-loading-spinner></app-loading-spinner>
			</span>
		</ol>
	</nav>
</div>

<div class="tab-container">
	<ul class="cp-nav-tabs" id="myTab" role="tablist">
		<li class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab active" data-bs-toggle="tab" role="tab" aria-selected="true"
				id="nav-base-tab" aria-controls="nav-base" data-bs-target="#nav-base">
				<fa-icon [icon]="['fas', 'info-circle']" size="sm"></fa-icon>
				Info
			</button>
		</li>

		<li *ngIf="protocolReady && availableSets.length > 0" class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false" id="nav-sets-tab"
				aria-controls="nav-sets" data-bs-target="#nav-sets">
				<fa-icon [icon]="['fas', 'link']" size="sm"></fa-icon>
				Linked Protocol Sets
				<span *ngIf="linkedProtocolSetInForm.length" class="cp-tab-badge">
					{{ linkedProtocolSetInForm.length | number }}
				</span>
			</button>
		</li>
	</ul>
	<form *ngIf="theForm" [formGroup]="theForm">

		<div class="tab-content" id="nav-tabContent">
			<div class="tab-pane show active" id="nav-base" role="tabpanel" aria-labelledby="nav-base-tab">
				<div class="cp-general-width-limit">
					<div>
						<label>Commercial Type</label>
						<button type="button" class="btn btn-outline-secondary btn-sm ms-1" data-bs-toggle="modal"
							data-bs-target="#commercialTypesModal">
							<fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
							Info
						</button>
					</div>
					<div class="form-check ms-1 mb-1" *ngFor="let commercialTypeSelection of commercialTypeSelections; let i = index">
						<input class="form-check-input" type="radio" formControlName="commercial_type" name="commercial_type"
							[id]="'commercial_type_' + commercialTypeSelection.value" [value]="commercialTypeSelection.value" />
						<label class="form-check-label" [for]="'commercial_type_' + commercialTypeSelection.value">
							<span *ngIf="i > 0">{{ i }}.</span> {{ commercialTypeSelection.label }}
							<fa-icon [icon]="['fas', 'question-circle']" [ngbPopover]="commercialTypePopupContent"
								popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body"></fa-icon>
						</label>

						<ng-template #commercialTypePopupContent>
							<div class="cp-popover-banner">{{ (i + 1) }}. {{ commercialTypeSelection.label }}</div>
							<ul class="ps-1 ms-1">
								<li *ngFor="let line of commercialTypeSelection.info.trim().split('\n')"
									[ngClass]="{ 'ms-4': line.startsWith('\t') }">
									{{ line }}
								</li>
							</ul>
						</ng-template>
					</div>

					<div class="cp-compact-form-group border-top mt-2 pt-2">
						<label for="commercial_info">
							Commercial Notes
							<fa-icon [icon]="['fas', 'question-circle']" placement="end"
								ngbTooltip="Information about commercials.  What is billing based on?  Specific protocols?">
							</fa-icon>
						</label>
						<textarea id="commercial_info" formControlName="commercial_info" class="form-control" rows="10"
							placeholder="Information about commercials"></textarea>
					</div>

				</div>
			</div>

			<div class="tab-pane" id="nav-sets" role="tabpanel" aria-labelledby="nav-sets-tab">
				<div *ngIf="protocolReady && availableSets.length > 0" class="cp-general-width-limit">
					<div class="text-start mb-2">
						<button type="button" class="btn btn-sm btn-outline-info me-1 dropdown-toggle" id="addSetButton"
							[disabled]="loading" data-bs-toggle="dropdown" aria-expanded="false">
							<fa-icon [icon]="['fas', 'plus']"></fa-icon>
							Add a Protocol Set
						</button>
						<ul class="dropdown-menu cp-scrollable-menu" aria-labelledby="addSetButton">
							<li *ngFor="let pSet of availableSets; let i = index" class="dropdown-item text-info cp-pointer"
								(click)="addProtocolSetFromDropDown(pSet)" [ngClass]="{ 'border-top': i > 0 }"
								[ngbPopover]="pSetPopupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
								container="body">
								{{ pSet.name }}
								<ng-template #pSetPopupContent>
									<app-card-protocol-set [object]="pSet" [forStaff]="true"></app-card-protocol-set>
								</ng-template>
							</li>
						</ul>
					</div>

					<div *ngIf="linkedProtocolSetInForm.length > 0">
						<table class="cp-std-table">
							<thead>
								<tr>
									<th>Linked Protocol Set</th>
									<th colspan="2">Projected Monthly Limit (MB)</th>
									<th>Exclude B.Code</th>
									<th class="cp-icon-header"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let pSet of linkedProtocolSetInForm">
									<td class="align-middle">
										<a [ngbPopover]="pSetPopupContent" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
											container="body">
											{{ pSet.name }}
										</a>
									</td>
									<td style="max-width:17ch">
										<input type="number" [id]="'pset_projected_' + pSet.id"
											[formControlName]="'pset_projected_' + pSet.id" style="max-width:16ch"
											class="form-control text-end display-inline" [min]="0" [max]="ac.maxMeterLimit"
											(keyup)="onProtocolSetProjectedChange(pSet.id)" />
									</td>
									<td class="align-middle text-start text-nowrap">
										{{ nicePsetProjected[pSet.id] }}
									</td>
									<td>
										<input type="text" [id]="'pset_exclude_billing_code_' + pSet.id"
											[formControlName]="'pset_exclude_billing_code_' + pSet.id" style="max-width:12ch"
											class="form-control display-inline" />
									</td>
									<td class="align-middle">
										<button type="button" class="btn btn-outline-danger float-end"
											(click)="removeProtocolSetFromForm(pSet.id)" ngbTooltip="Unlink Protocol Set">
											<fa-icon [icon]="['fas', 'trash-alt']" size="sm"></fa-icon>
										</button>
									</td>
									<ng-template #pSetPopupContent>
										<app-card-protocol-set [object]="pSet" [forStaff]="true"></app-card-protocol-set>
									</ng-template>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</form>

	<div class="cp-form-padding"></div>

	<div *ngIf="!loading && theForm" class="cp-form-buttons">
		<div class="cp-form-buttons-inner">
			<button class="btn btn-primary me-1" type="button" (click)="onSubmit()" [disabled]="!theForm.valid || saving">
				<fa-icon [icon]="ac.actionIcons.submit"></fa-icon> Save
			</button>
			<button class="btn btn-outline-secondary" type="button" (click)="onCancel()" [disabled]="saving">
				<fa-icon [icon]="ac.actionIcons.cancel"></fa-icon> Cancel
			</button>

			<span class="gj-75 ps-2">* Required</span>
		</div>
	</div>

	<div class="modal" id="commercialTypesModal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Commercial Types</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeCommercialTypesModal">
					</button>
				</div>
				<div class="modal-body">
					<div class="mb-1" *ngFor="let keyCommercialType of ac.keyCommercialTypes; let i = index">
						<div class="fw-bold">{{ (i + 1) }}. {{ keyCommercialType.label }}</div>
						<ul class="ms-3 ps-2">
							<li *ngFor="let line of keyCommercialType.info.trim().split('\n')"
								[ngClass]="{ 'ms-4': line.startsWith('\t') }">
								{{ line }}
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>